import React  from 'react';
import './App.css';

import Campeonato from './Campeonato.js';

function App() {

	let hashSub = "simulador-auto";

	let [ state, setState ] = React.useState({ scrolled: false });


	const baseUrl = "#2025/Copa-do-Mundo-de-Clubes/Unico/";

	return (
		<>
			<div className="App">
				<Campeonato key={1172} campeonato={1172} baseUrl={baseUrl} subUrl={hashSub}/>
			</div>
		</>
	);
}


export default App;
